import { Flex, Select } from "antd";
import React from "react";

const CustomSelect = ({
  title,
  placeholder = "-",
  options,
  value,
  onChange,
  required,
  style,
  disabled,
  allowClear = false,
  showSearch = false,
}) => {
  return (
    <Flex vertical gap={"2px"} style={{ width: "100%" }}>
      {title && (
        <p style={{ fontSize: "13px" }}>
          {required && <span style={{ color: "#f00" }}>*</span>}
          {title}:
        </p>
      )}
      <Select
        allowClear={allowClear}
        showSearch={showSearch}
        placeholder={placeholder}
        style={{ ...style, width: "100%", height: "40px" }}
        options={options}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </Flex>
  );
};

export default CustomSelect;
